// extracted by mini-css-extract-plugin
module.exports = {"container":"FeaturedLengjais-module--container--1Isx0","title":"FeaturedLengjais-module--title--3VELD"};